import React from 'react'
import BaseDropdownSelect from '@paintscout/ui/components/DropdownSelect'
import type { DropdownSelectProps } from '@paintscout/ui/components/DropdownSelect'
import DropdownSelectMenuItem from './DropdownSelectMenuItem'

export type {
  DropdownSelectOption,
  DropdownSelectPlaceholder,
  DropdownSelectProps,
  SingleSelectProps,
  MultiSelectProps,
  GroupedDropdownSelectOption
} from '@paintscout/ui/components/DropdownSelect'

export default function DropdownSelect(props: DropdownSelectProps) {
  return <BaseDropdownSelect renderMenuItem={DropdownSelectMenuItem} {...props} />
}
